/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { CSSTransition } from 'react-transition-group';
import cls from 'classnames';
import makeIconName from '../../utils/makeIconName';
import NavBar from './Navbar';
import { LOGIN_LINK, LOGOUT_LINK } from '../../constants/menu';
import Link from '../../components/Link';
import styles from './index.module.scss';
import { ANIM_SPEED } from '../../constants/anim';
const Sidebar = ({ onClickClose, isOpen, isLogged, topOffset = 0, hideNav }) => {
    return (React.createElement(CSSTransition, { in: isOpen, classNames: 'sidebar', timeout: ANIM_SPEED, unmountOnExit: true },
        React.createElement("div", { id: 'sidebarBlock', className: styles.sidebarBlock, style: { top: topOffset, height: `calc(100% - ${topOffset}px)` } },
            React.createElement("div", { id: 'sidebar', className: styles.sidebarWrap },
                React.createElement("div", { className: styles.topSection },
                    React.createElement("button", { "aria-label": 'close', type: 'button', onClick: onClickClose, className: styles.closeBtn },
                        React.createElement("i", { className: `${styles.iconClose} ${makeIconName('cross', 'x24')}` }))),
                !hideNav && (React.createElement("div", { className: styles.mainSection },
                    React.createElement(NavBar, { withoutMyAccount: !isLogged }))),
                React.createElement("div", { className: cls(styles.bottomSection, styles.verticalLayout) },
                    isLogged && (React.createElement(Link, Object.assign({}, LOGOUT_LINK, { withIcon: true, iconPosition: 'right', iconName: 'logout', withoutFill: true }))),
                    !isLogged && !hideNav && (React.createElement("div", { className: cls(styles.authorizationWrapper, styles.verticalLayout) },
                        React.createElement(Link, Object.assign({}, LOGIN_LINK, { withIcon: true, iconName: 'login', withoutFill: true })))))))));
};
export default Sidebar;
